import axios from "axios"

import CisSearchTagService from "@/services/cis-searchtag.service";

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default class makeDtSetSearchTag {
    constructor (category, st_dt, en_dt) {
        this.sel_category = category
        this.st_dt = st_dt
        this.en_dt = en_dt

        this.majorClsList = []
        this.brandList = []
    }

    async initialize() {
        await this.getMajorClsList()
    }

    async getMajorClsList() {
        // 선택한 카테고리의 대분류 정보를 획득한다. (데이터 셋 생성 시 대분류 필터 적용 용도)
        const firstClasses = await CisSearchTagService.listFirstClass({
            ctgSq: this.sel_category
        }, source);

        if (firstClasses.data.success)
            this.majorClsList = firstClasses.data.data
    }

    async run() {
        var resDataset = []; 

        var gubunTypes = ['attributes', 'brands', 'nonbranded']

        for (const type of gubunTypes) {
            // gubun 데이터 획득
            const response = await CisSearchTagService.listGubun({
                startDate : this.st_dt,
                endDate : this.en_dt,
                ctgSq : this.sel_category,
                fclsSq : null,
                brand : type === 'nonbranded' ? 'NONBRANDED' : null,
                middle : null,
                type : type === 'nonbranded' ? 'attributes' : type,
            }, source)

            var gubuns = [];

            if (response && response.status === 200) {
                for(const item of response.data.data)
                    gubuns.push(item.value)
            }

            if (type === 'brands') {
                for (const gubun of gubuns) {
                    // tag
                    const tagResp = await CisSearchTagService.getBrandPinDataExp({
                        startDate : this.st_dt,
                        endDate : this.en_dt,
                        ctgSq : this.sel_category,
                        fclsSq : null,
                        brand : null,
                        middle : null,
                        type : type,
                        gubuns : [gubun]
                    }, source);
                    
                    if (tagResp && tagResp.status === 200) {
                        var brdTags = [];

                        if (tagResp.data && tagResp.data.data && tagResp.data.data.length > 0) {
                            var chartCat = tagResp.data.data[0].date.split(',');                            

                            for(const item of tagResp.data.data) {
                                brdTags.push({
                                    tag: item.sub,
                                    criteria: item.subTitle,
                                    brand: item.brand,
                                    freq: item.freq.split(',')
                                });     
                            }

                            var sheet_nm = "";

                            if (gubun === '라인 브랜드')
                                sheet_nm = "TAG 순위 및 월별 검색량(라인 브랜드)_전체";
                            else
                                sheet_nm = "TAG 순위 및 월별 검색량(상품명)_전체";

                            if (brdTags.length == 0)
                                continue;

                            resDataset.push({'sheet_type': 1, 'sheet_nm': sheet_nm, 'data': brdTags, 'cat': chartCat})
                        }
                    }       
                }
            }
            else {
                // tag
                const tagResp = await CisSearchTagService.getBrandPinDataExp({
                    startDate : this.st_dt,
                    endDate : this.en_dt,
                    ctgSq : this.sel_category,
                    fclsSq : null,
                    brand : type === 'nonbranded' ? 'NONBRANDED' : null,
                    middle : null,
                    type : 'attributes',
                    gubuns : gubuns
                }, source);
                
                if (tagResp && tagResp.status === 200) {
                    var brdTags = [];

                    if (tagResp.data && tagResp.data.data && tagResp.data.data.length > 0) {
                        var chartCat = tagResp.data.data[0].date.split(',');                            

                        for(const item of tagResp.data.data) {
                            brdTags.push({
                                tag: item.sub,
                                criteria: item.subTitle,
                                freq: item.freq.split(',')
                            });     
                        }

                        var sheet_nm = "";

                        switch(type) {
                            case 'attributes':
                                sheet_nm = "TAG 순위 및 월별 검색량(속성)_전체";
                                break;
                            case 'nonbranded':
                                sheet_nm = "TAG 순위 및 월별 검색량(NB)_전체";
                                break;
                        }

                        if (brdTags.length == 0)
                            continue;

                        resDataset.push({'sheet_type': 0, 'sheet_nm': sheet_nm, 'data': brdTags, 'cat': chartCat})
                    }
                }  
            }
        }

        if (this.majorClsList.length > 0) {
            for (const major of this.majorClsList) {
                for (const type of gubunTypes) {
                    // gubun 데이터 획득
                    const response = await CisSearchTagService.listGubun({
                        startDate : this.st_dt,
                        endDate : this.en_dt,
                        ctgSq : this.sel_category,
                        fclsSq : major.id,
                        brand : type === 'nonbranded' ? 'NONBRANDED' : null,
                        middle : null,
                        type : type === 'nonbranded' ? 'attributes' : type,
                    }, source)

                    var gubuns = [];

                    if (response && response.status === 200) {
                        for(const item of response.data.data)
                            gubuns.push(item.value)
                    }

                    if (type === 'brands') {
                        for (const gubun of gubuns) {
                            // tag
                            const tagResp = await CisSearchTagService.getBrandPinDataExp({
                                startDate : this.st_dt,
                                endDate : this.en_dt,
                                ctgSq : this.sel_category,
                                fclsSq : major.id,
                                brand : null,
                                middle : null,
                                type : type,
                                gubuns : [gubun]
                            }, source);
                            
                            if (tagResp && tagResp.status === 200) {
                                var brdTags = [];

                                if (tagResp.data && tagResp.data.data && tagResp.data.data.length > 0) {
                                    var chartCat = tagResp.data.data[0].date.split(',');                            

                                    for(const item of tagResp.data.data) {
                                        brdTags.push({
                                            tag: item.sub,
                                            criteria: item.subTitle,
                                            brand: item.brand,
                                            freq: item.freq.split(',')
                                        });     
                                    }

                                    var sheet_nm = "";

                                    if (gubun === '라인 브랜드')
                                        sheet_nm = `TAG 순위 및 월별 검색량(라인 브랜드)_${major.title}`;
                                    else
                                        sheet_nm = `TAG 순위 및 월별 검색량(상품명)_${major.title}`;

                                    if (brdTags.length == 0)
                                        continue;

                                    resDataset.push({'sheet_type': 1, 'sheet_nm': sheet_nm, 'data': brdTags, 'cat': chartCat})
                                }
                            }       
                        }
                    }
                    else {
                        // tag
                        const tagResp = await CisSearchTagService.getBrandPinDataExp({
                            startDate : this.st_dt,
                            endDate : this.en_dt,
                            ctgSq : this.sel_category,
                            fclsSq : major.id,
                            brand : type === 'nonbranded' ? 'NONBRANDED' : null,
                            middle : null,
                            type : 'attributes',
                            gubuns : gubuns
                        }, source);
                        
                        if (tagResp && tagResp.status === 200) {
                            var brdTags = [];

                            if (tagResp.data && tagResp.data.data && tagResp.data.data.length > 0) {
                                var chartCat = tagResp.data.data[0].date.split(',');                            

                                for(const item of tagResp.data.data) {
                                    brdTags.push({
                                        tag: item.sub,
                                        criteria: item.subTitle,
                                        freq: item.freq.split(',')
                                    });     
                                }

                                var sheet_nm = "";

                                switch(type) {
                                    case 'attributes':
                                        sheet_nm = `TAG 순위 및 월별 검색량(속성)_${major.title}`;
                                        break;
                                    case 'nonbranded':
                                        sheet_nm = `TAG 순위 및 월별 검색량(NB)_${major.title}`;
                                        break;
                                }

                                if (brdTags.length == 0)
                                    continue;

                                resDataset.push({'sheet_type': 0, 'sheet_nm': sheet_nm, 'data': brdTags, 'cat': chartCat})
                            }
                        }  
                    }
                }
            }
        }

        return resDataset
    }
}